import React, { useEffect, useState } from 'react';
import { Box, Theme, Typography } from '@mui/material';

import { convertFromDesignToLayoutCoordinates } from '../../library/layout-geometry/coordinates';
import { getDistanceFormatterSelector } from '../../store/selectors/getDistanceFormatterSelector';
import { getCurrentCameraType } from '../../store/slices/camera/selectors';
import { threeJsDom } from '../../three/util/events/ThreeJSDom';
import { GlobalThreeJSDomObjectEvent } from '../../three/util/events/types';
import { useAppSelector } from '../hooks';

const CoordinatesLabel = () => {
  const cameraType = useAppSelector(getCurrentCameraType);
  const isUsingLayoutCoordinates = cameraType === 'orthographic-layout';
  const distanceFormatter = useAppSelector(getDistanceFormatterSelector);

  const [x, setX] = useState(0);
  const [y, setY] = useState(0);

  const getCoordinatesUpdater = (isUsingLayoutCoordinates: boolean) => (event: GlobalThreeJSDomObjectEvent) => {
    const { worldPosition } = event.eventPosition;
    const { x, y } = isUsingLayoutCoordinates ? convertFromDesignToLayoutCoordinates(worldPosition) : worldPosition;
    setX(x);
    setY(y);
  };

  useEffect(() => {
    const updateCoordinates = getCoordinatesUpdater(isUsingLayoutCoordinates);
    threeJsDom.addGlobalListener('mousemove', updateCoordinates);
    return () => threeJsDom.removeGlobalListener('mousemove', updateCoordinates);
  }, [isUsingLayoutCoordinates]);

  if (cameraType === 'perspective-layout') return null;

  return (
    <Box
      sx={{
        display: { xs: 'none', md: 'block' },
        position: 'absolute',

        right: '72px',
        bottom: '8px',

        minWidth: 100,
        p: 1,
        textAlign: 'left',

        userSelect: 'none',
        zIndex: (theme: Theme) => theme.zIndex.drawer - 1,
      }}
    >
      <Typography variant="body2" color="textSecondary" sx={{ display: 'block' }}>
        X: {distanceFormatter(x) ?? '0'}
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ display: 'block' }}>
        Y: {distanceFormatter(y) ?? '0'}
      </Typography>
    </Box>
  );
};

export default CoordinatesLabel;
